import {makeStyles} from '@material-ui/core';

/* #21094E - dark purple
#511281 - purple
#4CA1A3 - green
#45E1AD - light green */

export const useStyles=makeStyles({
    container:{
        background:'linear-gradient(to right,#511281,#45E1AD)',
        padding:'30px',
        display: 'grid',
        gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))',
        gridColumnGap:'40px',
        gridRowGap:'40px'
    },
    paper:{
        padding:'20px',
    },
    playButton:{
        background: 'linear-gradient(to left bottom,#511281,#45E1AD )',
        color:'#fff'
    }

})